import * as PIXI from 'pixi.js'

export class PaylineGeometry extends PIXI.RopeGeometry {
    public fading: number[]

    private _fadingBuffer: PIXI.Buffer | null = null

    private ensureFadingBuffer(): PIXI.Buffer {
        if (this._fadingBuffer != null) {
            return this._fadingBuffer
        }

        const size = this.points.length * 2
        const buffer = new PIXI.Buffer({ data: new Float32Array(size).fill(1) })

        this.addAttribute('aFading', {
            buffer,
            format: 'float32',
            stride: 4,
            offset: 0,
        })

        this._fadingBuffer = buffer
        return buffer
    }

    public updateVertices(): void {
        super.updateVertices()

        const points = this.points
        const buffer = this.ensureFadingBuffer()
        const required = points.length * 2

        if ((buffer.data as Float32Array).length !== required) {
            buffer.data = new Float32Array(required).fill(1)
        }

        const data = buffer.data as Float32Array

        for (let index = 0; index < points.length; index++) {
            const alpha = this.fading != null ? (this.fading[index] ?? 1) : 1
            data[index * 2] = alpha
            data[index * 2 + 1] = alpha
        }

        buffer.update()
    }
}
